'use strict';

import './security';

// Load jQuery
import jQuery from 'jquery';
window.jQuery = window.$ = jQuery;

// Load Bootstrap 5
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// Load Flatpickr - datetime picker
import flatpickr from 'flatpickr';
jQuery.fn.extend({
  flatpickr: function (opt) {
    flatpickr(this, opt);
  }
});
window.flatpickr = flatpickr;

// Load Html5Qrcoder - For QR scan
const {
  Html5Qrcode
} = require('html5-qrcode');
window.Html5Qrcode = Html5Qrcode;